module.exports = __webpack_public_path__ + "static/media/AdjustOverlay.f14ceb1d.png";